import { Grid, Button, TextField } from "@mui/material"
import { RootState, useAppThunkDispatch } from "../../../redux/store"
import { useHistory, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import React, { useEffect, useState } from "react"
import { PATH } from "../../../constants/paths"
import { setSurveyGroups } from "src/redux/slices/configSlice"
import { getTranslations, setWeekFieldError } from "src/utils/helper"
import { updateWarnOnTabChangeToStore } from "../helper"
import { useTranslation } from "react-i18next"
import { Translates } from "src/i18n/i18n"
import BreadCrumb from "src/components/BreadCrumb/BreadCrumb"
// import { getMaxValue } from "../Variances/Utils/FunctionsHelper"
import { v4 as uuidv4 } from "uuid"
interface IGroup {
  GroupName: string
  GroupLabel: string
  GroupId: number
}
const CreateEditGroupName = () => {
  const { t } = useTranslation<any>()

  const [errorMsg, setErrorMsg] = useState(false)
  const [groupNameErr, setGroupNameErr] = useState("")
  const [lengthErrorMsg, setLengthErrorMsg] = useState(false)
  const [characterErrorMsg, setCharacterErrorMsg] = useState(false)
  const location = useLocation() as any
  let search = window.location.search || ""
  const history = useHistory()
  const dispatch = useAppThunkDispatch()
  const configData = useSelector((state: RootState) => state.config)

  const surveyGroups = useSelector(
    (state: RootState) => state.config.surveyGroups
  )

  const [form, setForm] = React.useState<IGroup>({
    GroupName: "",
    GroupLabel: "",
    GroupId: 0
  })

  const [weekIVFields, setWeekIVFields] = useState({
    GroupName: ""
  })

  useEffect(() => {
    const locationState = { ...location?.state }

    if (locationState.isEdit === true) {
      setForm({
        ...locationState.data
      })
    }
  }, [])

  const onFormChange = e => {
    updateWarnOnTabChangeToStore(true)
    const val = e.target.value || ""
    setErrorMsg(false)
    setLengthErrorMsg(false)
    setCharacterErrorMsg(false)

    if (e.target?.name === "GroupName") {
      setGroupNameErr("")
      // if (val.length > 30) {
      //   setGroupNameErr("Group Name length can not be more than 30")
      // }
      setForm({ ...form, [e.target.name]: val })

      // setWeekFieldError({ setWeekIVFields, val, t, field: e.target.name })
    } else if (e.target?.name === "GroupLabel") {
      setForm({ ...form, [e.target.name]: val })
    }
  }

  const onSaveClick = () => {
    const duplicateGroup = surveyGroups.filter(function (itm) {
      return form.GroupName == itm.GroupName && form.GroupId !== itm.GroupId
    })

    if (duplicateGroup.length > 0) {
      setErrorMsg(true)
      setGroupNameErr("Duplicate Group Name")
      window.scrollTo(0, 0)
      return
    }
    const _sortOrder =
      configData?.surveyGroups?.length > 0
        ? configData?.surveyGroups?.reduce(
            (a: any, b: { SortOrder: number }) => Math.max(b.SortOrder) || a,
            0
          )
        : 0
    let _item: any = {
      GroupName: form.GroupName,
      GroupLabel: form.GroupLabel,
      GroupId: location.state?.data?.GroupId,
      SortOrder: location.state?.isEdit
        ? location.state?.data?.SortOrder
        : _sortOrder + 1
    }

    let _dt = [] as any
    if (location.state?.isEdit) {
      _dt = [
        ...configData?.surveyGroups.map(m =>
          m.GroupId === _item.GroupId ? { ..._item } : { ...m }
        )
      ]
    } else {
      _item.GroupId = uuidv4()
      _dt = [...configData?.surveyGroups, _item]
    }

    updateWarnOnTabChangeToStore(false)
    setTimeout(() => {
      if (!lengthErrorMsg && !characterErrorMsg) {
        if (location.state?.isEdit) {
          dispatch(setSurveyGroups(_dt))
          history.push(PATH.CREATE_EDIT_SURVERYS + search, {
            isEdit: location.state?.isParentEdit,
            data: { ...location.state?.form, ...{ surveyGroups: _dt } }
          })
        } else {
          if (Object.keys(duplicateGroup).length == 0) {
            dispatch(setSurveyGroups(_dt))
            history.push(PATH.CREATE_EDIT_SURVERYS + search, {
              isEdit: location.state?.isParentEdit,

              data: { ...location.state?.form, ...{ surveyGroups: _dt } }
            })
          } else {
            setErrorMsg(true)
            window.scrollTo(0, 0)
          }
        }
      }
    })
  }
  const onCancelClick = () => {
    updateWarnOnTabChangeToStore(false)
    setTimeout(() => {
      history.push(PATH.CREATE_EDIT_SURVERYS + search, {
        isEdit: location.state?.isParentEdit,

        data: { ...location.state?.form }
      })
    })
  }

  const getLookupBreadcrumb = () => {
    const breadcrumbLookUP = {
      custLinks: {
        "@landingPage": `configuration/surveys`,
        "@SurveyName": `configuration/createEditSurveys`
      },
      mapObj: {
        "@landingPage": "Surveys",
        "@SurveyName": {
          name: location?.state?.surveyName,
          state: {
            isEdit: location.state?.isParentEdit,

            data: { ...location.state?.form }
          }
        },
        Surveys: getTranslations(
          t,
          location?.state?.isEdit ? "Edit_Group" : "New_Group"
        )
      }
    }
    return breadcrumbLookUP
  }

  const getBreadcrumbConfig = () => {
    let currentPath: string =
      "##configuration##/@landingPage/@SurveyName/Surveys"
    let bConfig: any = {
      currentPath,
      ...getLookupBreadcrumb(),
      showHomeIcon: false
    }
    return bConfig
  }
  const validationCheck = () => {
    if (!form.GroupName) {
      return true
    }
    return false
  }
  return (
    <div>
      <Grid className="main-container" container>
        <div className="main-toolbar">
          <div className="main-container">
            <Grid container>
              <Grid item sm={12}>
                <div className="custom-breadcrumb CP">
                  <BreadCrumb
                    customPath={"New Survey"}
                    breadCrumbInfo={getBreadcrumbConfig()}
                    renderedPage={""}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <Grid item xs={12} sm={12}>
          <Grid container>
            <Grid item xs={12} sm={3}>
              <TextField
                data-testid="groupName"
                fullWidth
                label={`${getTranslations(t, Translates.Group_Name)}*`}
                variant="filled"
                autoSave="false"
                autoComplete="off"
                className="custom-form-control"
                onChange={e => onFormChange(e)}
                name="GroupName"
                value={form.GroupName || ""}
                error={groupNameErr || !!weekIVFields.GroupName ? true : false}
                helperText={groupNameErr || weekIVFields.GroupName}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} className="mb-8">
          <Grid container>
            <Grid item xs={12} sm={3}>
              <TextField
                data-testid="groupLabel"
                fullWidth
                label={`${getTranslations(t, Translates.Group_Label)}`}
                variant="filled"
                autoSave="false"
                autoComplete="off"
                className="custom-form-control"
                onChange={e => onFormChange(e)}
                name="GroupLabel"
                value={form.GroupLabel || ""}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <div className="inner-view__footer">
            <Button
              variant="text"
              className="primary-btn cancel-btn mr-5"
              data-testid="cancel"
              onClick={() => onCancelClick()}
            >
              {getTranslations(t, Translates.Cancel)}
            </Button>
            <Button
              data-testid="save"
              variant="contained"
              onClick={() => onSaveClick()}
              disabled={validationCheck()}
              className="primary-btn"
            >
              {getTranslations(t, Translates.Save)}
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default CreateEditGroupName
